import React from "react";
import './email-input.css';

type EmailInputProps = {
    id: string;
    name: string;
    value: string;
    onChange: (value: string) => void;
    icon?: string;
    placeholder?: string;
    error?: string;
};

export const EmailInput = ({ id, name, onChange, value, icon, placeholder, error }: EmailInputProps) => {
    const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        onChange(e.target.value);
    };

    return (
        <>
            <div className="email-input-container">
                {icon && <img src={icon} alt="icon" />}
                <input id={id} name={name} type="email" value={value} onChange={handleChange} placeholder={placeholder ?? ''} />
            </div>
            {error &&
                <div className="email-input-error">
                    {error}
                </div>
            }
        </>
    );
};